<!-- TODO: Play Showreel + UI to close show reel. Load showreel from vimeo? -->

<template>
<main id="home">
    <VideoBackground 
        :data="introVideo"
        v-if="introVideo" 
    />

    <!-- 
    <VideoBackground 
        v-if="showreel" 
        ref="showreel"
        :data="showreel"
        class="showreel"
        :class="{'active' : isShowreelPlaying}" 
    />
    -->
    
    
    <VideoPlayer 
        v-if="showreel"
        ref="showreel"
        class="showreel"
        :class="{'active' : isShowreelPlaying}" 
        :data="showreel"
        :controls="false"
        :loop="true"
        :autoplay="true"
        @loaded="onShowreelLoaded"
    />
   
    
    <SecondaryNavigation 
        :text="videoCta"
        :showCloseIcon="showCloseIcon"
        :hasLink="true"
        @clicked="onToggleVideo"
        brightness="light"
    />

</main>
</template>

<script>
import SecondaryNavigation from '../components/SecondaryNavigation'
import VideoBackground from '../components/VideoBackground'
import VideoPlayer from '../components/VideoPlayer'


export default {

    components: {
        VideoBackground,
        VideoPlayer,
        SecondaryNavigation
    },

    data: function() {
        return {
            isLoading: false,
            videoLoaded: false,
            videoCta: '',
            videoLabelOpen: 'Play showreel',
            videoLabelClose: 'Close showreel',
            showCloseIcon: false,

            introVideo: '',
            showreel: '',
        }
    },

    mounted() {
        this.videoCta = this.videoLabelOpen
        
        
        this.getData()
    },

    beforeDestroy() {
        // Return to initial state when leaving Home
        this.$store.dispatch('stopShowreel')
    },

    methods: {

        getData() {
            
            // DATA is already loaded in Preloader - Saved in Store
            this.introVideo = [this.$store.state.homeData.introVideo]
            this.showreel = [this.$store.state.homeData.showreelVideo]
            
            this.$emit('loaded') // Tell App data is ready
            
            // this.isLoading = true
            // let url = "/data/home.json"
            // 
            // return axios
            //     .get(url)
            //     .then(res => {
            //         this.introVideo = [res.data.introVideo]
            //         this.showreel = [res.data.showreelVideo]
            // 
            //         this.isLoading = false
            //     })
            //     .catch(error => {
            //         throw new Error('Data Failed: ', error);
            //     })
        },



        onToggleVideo() {
            // console.log('toggle video: ', this.isShowreelPlaying);
            if (this.isShowreelPlaying === true) {
                this.$store.dispatch('stopShowreel')
            } else {
                this.$store.dispatch('playShowreel')

            }
        },

        onOpenVideo() {

            this.videoCta = this.videoLabelClose
            this.showCloseIcon = true
            this.isShowreelPlaying = true
            
            console.log(this.$refs.showreel.isLoaded);
            this.$refs.showreel.setVideoSize()
            
            if (this.$refs.showreel.isLoaded === true) {
                this.$refs.showreel.play()
            } else {
                this.$refs.showreel.load()
            }
            
        },

        onCloseVideo() {
            this.$refs.showreel.stop()

            this.videoCta = this.videoLabelOpen
            this.showCloseIcon = false
            this.isShowreelPlaying = false
        },
        
        onShowreelLoaded() {
            this.$refs.showreel.play()
        },

    },

    watch: {
        isShowreelPlaying() {
            // console.log('isShowreelPlaying:' , newValue, oldValue);
            if (this.isShowreelPlaying === true) {
                this.onOpenVideo()

            } else {
                this.onCloseVideo()
            }
        },
    },

    computed: {
        isShowreelPlaying: {
            get: function() {
                return this.$store.state.isShowreelPlaying
            },
            set: function() {}
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables';

#home {
    height: 100vh;

    .showreel {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.4s;
        
        &.active {
            visibility: visible;
            opacity: 1;
        }
    }
}
</style>
